import { ApiBaseResponseDto, ApiResponseCodeEnum } from './common-dtos';

export class ApiException extends Error {
  constructor(
    public readonly code: ApiResponseCodeEnum,
    message: string,
    public readonly response: ApiBaseResponseDto<null>,
  ) {
    super(message);
  }
}
